module.exports = __webpack_public_path__ + "img/pause.d2ab9bdc.svg";